/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessParty } from '../../models/business-party';

export interface FindBusinessPartyOfUser$Params {
}

export function findBusinessPartyOfUser(http: HttpClient, rootUrl: string, params?: FindBusinessPartyOfUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BusinessParty>>> {
  const rb = new RequestBuilder(rootUrl, findBusinessPartyOfUser.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BusinessParty>>;
    })
  );
}

findBusinessPartyOfUser.PATH = '/business-parties/of-user';
